export default __webpack_public_path__ + "static/media/slide03.59abfd26.jpg";